import React from 'react';
import { Badge, Card, CardBody, Col, Input, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';

interface ElementPaletteProps {
  addElement: (element: Element) => void;
  elements: Element[];
  name: string;
  setName: (name: string) => void;
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  file_id?: string;
}

const ElementPalette: React.FC<ElementPaletteProps> = ({ elements, addElement, name, setName }) => {
  const handleAddDropDownText = () => {
    const newTextElement: Element = {
      type: 'dropdown',
      subject: '',
      description: "",
      id: elements.length ? Math.max(...elements.map(element => element.id)) + 1 : 1,
    };
    addElement(newTextElement);
  };

  const handleAddText = () => {
    const newTextElement: Element = {
      type: 'text',
      subject: '',
      description: "",
      id: elements.length ? Math.max(...elements.map(element => element.id)) + 1 : 1,
    };
    addElement(newTextElement);
  };

  const handleAddVideo = () => {
    const newVideoElement: Element = {
      type: 'video',
      file_id: "",
      id: elements.length ? Math.max(...elements.map(element => element.id)) + 1 : 1,
      subject: '',
      description: ''
    };
    addElement(newVideoElement);
  };

  const handleAddImage = () => {
    const newImageElement: Element = {
      type: 'image',
      file_id: "",
      id: elements.length ? Math.max(...elements.map(element => element.id)) + 1 : 1,
      subject: '',
      description: ''
    }
    addElement(newImageElement);

  }

  return (
    <div>
      <Card>
        <CardBody>
          <div style={{ marginBottom: 32 }}>
            <H5 className="mb-3"> Page Name </H5>
            <Input type="text" required placeholder={"Page name"} onChange={(event: any) => setName(event.target.value)} value={name} />
          </div>
          <H5 className="mb-3"> Add Elements </H5>
          <div className="mb-3">
            <div className='mb-3 d-flex justify-content-between'>
              <Badge className="px-3 py-1 btn-hover-effect" color="primary" onClick={handleAddDropDownText} style={{ cursor: "pointer", width: '90px' }}>
                <p className="mb-0 "><strong> {"D"}</strong></p>
                <span className="mb-1">Dropdown</span>
              </Badge>
              <div className=' d-flex justify-content-end'>
                <Badge className="px-3 py-1 btn-hover-effect" color="primary" onClick={handleAddText} style={{ cursor: "pointer", width: '90px' }}>
                  <p className="mb-0 "><strong> {"T"}</strong></p>
                  <span className="mb-1">Text</span>
                </Badge>
              </div>
            </div>
            <div className='d-flex justify-content-between'>
              <Col sm className=''>
                <Badge className="px-3 py-1 btn-hover-effect" color="primary" onClick={handleAddImage} style={{ cursor: "pointer", width: '90px' }}>
                  <p className="mb-0 "><strong> {"I"}</strong></p>
                  <span className="mb-1">Image</span>
                </Badge>
              </Col>
              <Col className='d-flex justify-content-end'>
                <Badge className="px-3 py-1 btn-hover-effect" color="primary" onClick={handleAddVideo} style={{ cursor: "pointer", width: '90px' }}>
                  <p className="mb-0"><strong> {"V"}</strong></p>
                  <span className="mb-1">Video</span>
                </Badge>
              </Col>
            </div>
          </div>
        </CardBody>
      </Card>

    </div>
  );
};

export default ElementPalette;
